import EditObjectPanel from 'asset-actions-lib/components/modals/EditObjectPanel';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const EDIT_ACTION = {
  id: ACTION_IDS.EDIT,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "assetActionsLib.sharedActions.edit"
  }),
  onConfirm: () => {},
  actionGroup: 0,
  ModalOrPanel: EditObjectPanel
};